const a = {
  prefix: "tw-",
  content: [
    "./src/**/*.html",
    "./public/**/*.html",
    "./src/**/*.vue",
    "./src/**/*.js"
  ],
  theme: {
    fontFamily: {
      sans: ["roboto", "helvetica", "sans-serif"],
      proxima: ["proxima", "roboto", "helvetica"]
    },
    screens: {
      "tw-sm": "375px",
      "tw-md": "768px",
      "tw-lg": "992px",
      "tw-xl": "1200px",
      "tw-2xl": "1440px",
      "tw-3xl": "1600px",
      "tw-4xl": "1920px"
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      bold: 600
    },
    colors: () => {
      const r = {
        current: "currentColor",
        acv: {
          primary: {
            "dark-x": "#B2400A",
            dark: "#D44D0C",
            base: "#F26522",
            light: "#FAC9B2",
            "light-x": "#FEF2EC"
          },
          secondary: {
            "dark-x": "#00304D",
            dark: "#004066",
            base: "#004E7D",
            light: "#ADE0FF",
            "light-x": "#EBF6FF"
          },
          capital: {
            charcoal: "#53565A",
            orange: "#F26522",
            // aka acv.primary.base
            cloud: "#D0D3D4",
            jewel: "#522398",
            royal: "#1F145D"
          }
        },
        drivably: {
          primary: {
            "dark-x": "#001454",
            dark: "#0037B9",
            base: "#094EE8",
            light: "#DBE1FF",
            "light-x": "#FDFBFF"
          }
        },
        max: {
          primary: {
            "dark-x": "#001A40",
            dark: "#002F68",
            base: "#304E84",
            light: "#C2E9D9",
            "light-x": "#F0FAF6"
          },
          secondary: {
            "dark-x": "#00304D",
            dark: "#004066",
            base: "#004E7D",
            light: "#ADE0FF",
            "light-x": "#EBF6FF"
          }
        },
        monk: {
          primary: {
            "dark-x": "#001A40",
            dark: "#002F68",
            base: "#304E84",
            light: "#FAC9B2",
            "light-x": "#FEF2EC"
          }
        },
        black: {
          DEFAULT: "#000000",
          50: "rgba(0, 0, 0, 0.05)",
          120: "rgba(0, 0, 0, 0.12)",
          150: "rgba(0, 0, 0, 0.15)",
          180: "rgba(0, 0, 0, 0.18)",
          370: "rgba(0, 0, 0, 0.37)",
          500: "rgba(0, 0, 0, 0.5)",
          600: "rgba(0, 0, 0, 0.6)",
          670: "rgba(0, 0, 0, 0.67)",
          870: "rgba(0, 0, 0, 0.87)",
          hex: {
            50: "#F4F4F4",
            120: "#E4E4E4",
            150: "#DEDEDE",
            180: "#D7D7D7",
            370: "#ABABAB",
            500: "#8A8A8A",
            600: "#717171",
            670: "#5F5F5F",
            870: "#252525"
          }
        },
        blue: {
          50: "rgba(5, 102, 141, 0.05)",
          80: "rgba(5, 102, 141, 0.08)",
          120: "rgba(5, 102, 141, 0.12)",
          150: "rgba(5, 102, 141, 0.15)",
          180: "rgba(5, 102, 141, 0.18)",
          hex: {
            50: "#F4F8FA",
            80: "#EEF4F6",
            120: "#E5EEF2",
            150: "#DFEAEE",
            180: "#D8E5EB"
          }
        },
        gray: {
          medium: "#F1F2F3",
          dark: "#D3D3D3"
        },
        orange: {
          380: "rgba(242, 101, 34, 0.38)",
          hex: {
            380: "#FAC7B3"
          }
        },
        pink: {
          DEFAULT: "#FC4243",
          80: "rgba(252, 66, 67, 0.08)",
          120: "rgba(252, 66, 67, 0.12)",
          150: "rgba(252, 66, 67, 0.15)",
          hex: {
            80: "#FFF2F2",
            120: "#FFEAEA",
            150: "#FEE6E6"
          }
        },
        red: {
          100: "rgba(252, 78, 76, 0.1)",
          800: "rgba(252, 78, 76, 0.8)",
          900: "rgba(252, 78, 76, 0.9)",
          hex: {
            100: "#FFEEEE",
            800: "#FC7573",
            900: "#FC6260"
          }
        },
        white: {
          DEFAULT: "#FFFFFF",
          380: "rgba(255, 255, 255, 0.38)",
          hex: {
            380: "#FFFFFF"
          }
        },
        grey: {
          base: "#E0E0E0",
          "dark-x": "#212121",
          dark: "#757575",
          light: "#F5F5F5",
          "light-x": "#FAFAFA"
        },
        background: {
          light: "#FAFAFA",
          base: "#F1F1F1",
          dark: "#EAEAEA",
          white: "#FFFFFF"
        },
        text: {
          "link-on-light": "#004E7D",
          "link-on-dark": "#ADE0FF",
          primary: "#212121",
          secondary: "#545454",
          tertiary: "#757575",
          disable: "#A1A1A1",
          white: "#FFFFFF"
        },
        informational: {
          "dark-x": "#001D36",
          dark: "#0061A5",
          base: "#2196F5",
          light: "#B4DDFF",
          "light-x": "#F0F8FF"
        },
        success: {
          "dark-x": "#002114",
          dark: "#006C4C",
          base: "#00A576",
          light: "#BDFFDE",
          "light-x": "#F4FFF6"
        },
        error: {
          "dark-x": "#410002",
          dark: "#BA1A1A",
          base: "#FF5449",
          light: "#FFDAD6",
          "light-x": "#FFFBFF"
        },
        caution: {
          "dark-x": "#402D00",
          dark: "#795900",
          base: "#FFC000",
          light: "#FFEFD4",
          "light-x": "#FFFBEE"
        },
        border: {
          base: "#DCDFE8"
        },
        focus: {
          base: "#7b61ff"
        },
        transparent: "transparent"
      };
      return {
        primary: r.acv.primary,
        secondary: r.acv.secondary,
        capital: r.acv.capital,
        destructive: r.error,
        ...r
      };
    },
    extend: {
      spacing: {
        15: "3.75rem",
        17: "4.25rem",
        18: "4.5rem",
        19: "4.75rem",
        21: "5.25rem",
        25: "6.5rem",
        30: "7.5rem",
        31: "7.75rem",
        54: "13.5rem",
        58: "14.5rem",
        68: "17rem",
        76: "19rem",
        88: "22rem"
      },
      backgroundImage: (r) => ({
        "primary-gradient": `
          linear-gradient(
            90.72deg,
            ${r("colors.primary.base")} 0.15%,
            ${r("colors.pink.DEFAULT")} 87.52%
          )`,
        "capital-gradient": `
          linear-gradient(
            30deg,
            ${r("colors.acv.capital.royal")} 0.0%,
            ${r("colors.acv.capital.jewel")} 50.0%,
            ${r("colors.acv.capital.orange")} 100.0%
          )`,
        "capital-alt-gradient": `
          linear-gradient(
            90deg,
            ${r("colors.acv.capital.jewel")} 0.0%,
            ${r("colors.acv.capital.orange")} 70.0%
          )`
      })
    }
  },
  plugins: [],
  corePlugins: {
    preflight: !1
  }
};
export {
  a as default
};
